export const DEFAULT_TIMEZONE = 'America/Chicago';
